var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ApolloLink, Observable } from 'apollo-link';
import { createApolloFetch } from 'apollo-fetch';
import { BatchLink } from 'apollo-link-batch';
import { print } from 'graphql/language/printer';
var BatchHttpLink = (function (_super) {
    __extends(BatchHttpLink, _super);
    function BatchHttpLink(fetchParams) {
        var _this = _super.call(this) || this;
        _this.headers = {};
        _this.batchInterval = (fetchParams && fetchParams.batchInterval) || 10;
        _this.batchMax = (fetchParams && fetchParams.batchMax) || 10;
        _this.apolloFetch =
            (fetchParams && fetchParams.fetch) ||
                createApolloFetch({ uri: fetchParams && fetchParams.uri });
        _this.apolloFetch.batchUse(function (request, next) {
            request.options.headers = __assign({}, request.options.headers, _this.headers);
            next();
        });
        var batchHandler = function (operations) {
            return new Observable(function (observer) {
                var printedOperations = operations.map(function (operation) { return (__assign({}, operation, { query: print(operation.query) })); });
                _this.apolloFetch(printedOperations)
                    .then(function (data) {
                    observer.next(data);
                    observer.complete();
                })
                    .catch(observer.error.bind(observer));
            });
        };
        _this.batcher = new BatchLink({
            batchInterval: _this.batchInterval,
            batchMax: _this.batchMax,
            batchHandler: batchHandler,
        });
        return _this;
    }
    BatchHttpLink.prototype.request = function (operation) {
        this.headers = operation.getContext().headers || this.headers;
        return this.batcher.request(operation);
    };
    return BatchHttpLink;
}(ApolloLink));
export { BatchHttpLink };
//# sourceMappingURL=batchHttpLink.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-link-batch-http/lib/batchHttpLink.js
// module id = 440
// module chunks = 0